import { Injectable } from '@angular/core';

export const MODE_NORMAL  = 1;
export const MODE_OFFLINE = 3;

@Injectable()
export class StateService {

  _state: number = MODE_NORMAL;

  constructor() {
  }

  state(state): void {
    this._state = state;
  }

  get isNormal(): boolean {
    return this._state === MODE_NORMAL;
  }

  get isOffline(): boolean {
    return this._state === MODE_OFFLINE;
  }

}



// WEBPACK FOOTER //
// ./src/providers/state.service.ts